var React = require('react');

function Attach (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M9 15C9 6.716 15.716 0 24 0c8.284 0 15 6.716 15 15v16.498a1.5 1.5 0 01-3 0V15c0-6.628-5.372-12-12-12S12 8.372 12 15v22.5a7.5 7.5 0 0015 0V15a2.999 2.999 0 10-6 0v19.5a1.5 1.5 0 01-3 0V15a6 6 0 016-6 6 6 0 016 6v22.5C30 43.298 25.298 48 19.5 48S9 43.298 9 37.5V15z"}));
}

Attach.defaultProps = {"viewBox":"0 0 48 48"};

module.exports = Attach;

Attach.default = Attach;
